<span *ngIf="imageUrl " class="imageWrapper">
  <img alt="image" class="image" [src]="imageUrl">
  <ion-icon (click)="closeModal()" class="imageCloseIcon" name="close"></ion-icon>
</span>